var _defs, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCerebro04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:37.46px;}.b,.c{fill:none;stroke:#5a1372;stroke-linecap:round;stroke-linejoin:round;}.c{stroke-width:72px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.76,196.28s-6.53-48.89-65.96-45.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M742.29,502.83s49.32,.65,54.18-58.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M413.43,629.87s-1.19-49.31-60.69-51.95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M870.51,570.03l14.12-32.15c13.46-30.65,11.96-65.96-4.05-95.32l-23.65-43.37-.58-66.08c-.31-34.94-21.35-66.23-53.24-79.18l-36.1-14.66c-.54-60.53-33.65-115.9-86.24-144.2l-33.72-18.14c-48.96-26.35-109.2-15.89-146.79,25.49-38.99-40.7-100.47-50.08-149.83-22.86l-33.99,18.74c-53.01,29.23-85.72,85.19-85.18,145.72l-36.48,15.3c-32.22,13.52-53.07,45.17-52.76,80.11l.58,66.08-23.29,43.79c-15.77,29.64-16.66,64.97-2.42,95.38l14.94,31.89-14.41,31.13c-13.28,28.69-8.85,62.47,11.39,86.77l41.35,49.64,4.91,30.88c5.19,32.61,23,61.87,49.6,81.45l40.93,30.13c66.86,46.17,155.4,68.87,221.95,22.25l19.51-13.67,19.41,13.32c66.19,45.45,153.17,21.2,218.05-26.14l39.68-30.85c25.78-20.04,42.77-49.61,47.29-82.31l4.28-30.96,39.76-50.36c19.46-24.65,23.22-58.5,9.67-86.95l-14.7-30.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M131.85,576.57s35.97,21.22,86.69-.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M236.14,241.29s62.27-50.56,128.32,20.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M415.16,476.05s-126.49,17.86-158.45-133.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.01,497.78s-4.14-49.15,54.72-58.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M863.94,589.3s-35.59,21.86-86.69,.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.5,159.25s-77.99-18.78-107.05,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M754.95,378.11s-127.74,1.38-136.63,155.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.39,351.32s-.4,49.33,58.97,53.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M503.24,367.4s-18.7-45.64-75.22-26.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M769.38,241.54s-47.58-13.03-67.2,43.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M623.2,800.57s7.12-127.55,161.33-129.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M589.59,612.87s74.33,8.35,70.41,98.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.51,657.66s78.61,100.69,206.38,14.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.47,828.41s56.29-49.27,1.6-121.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 500.26,
    y1: 102.43,
    x2: 507.08,
    y2: 872.16
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerebro04);
export default __webpack_public_path__ + "static/media/cerebro-04.bd860bd88d4bbdffc255d2ef0c967925.svg";
export { ForwardRef as ReactComponent };